const constants = {
  paginationNumberKey: 'pagination-number',
  setPaginationNumber(number) {
    return localStorage.setItem(constants.paginationNumberKey, number);
  },
};

export default constants;
